// Shared state for Clarity initialization tracking
// This ensures Clarity is only initialized once across the application

let _clarityInitialized = false;

export function clarityInitialized(): boolean {
  return _clarityInitialized;
}

export function setClarityInitialized(value: boolean): void {
  _clarityInitialized = value;
}
